<script>
export default {
  name: "redemption-channel-detail",
  props: ["item"],
  data() {
    return {
      redemption: null,
      options: [
        { value: null, text: "Please select" },
        { value: "in store", text: "In Store" },
        { value: "online", text: "Online" },
        { value: "both", text: "Both" }
      ]
    };
  },
  computed: {
    redemption_id() {
      return `my_redemption_${this.item.id}`;
    }
  }
};
</script>

<template>
  <tr>
    <td>{{ item.name }}</td>
    <td>
      <b-form-select
        :id="redemption_id"
        v-model="redemption"
        :options="options"
      ></b-form-select>
    </td>
  </tr>
</template>
